export default __webpack_public_path__ + "static/media/check.63268ea3.svg";